import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react';
import { calculatePercentChange, cn } from '@/lib/utils';

export const ChangeIndicator = ({
  current,
  previous,
  className,
}: {
  current: number;
  previous: number;
  className?: string;
}) => {
  const change = calculatePercentChange(current, previous);

  if (change === null) {
    return (
      <span className={cn('text-xs font-medium text-positive', className)}>
        New
      </span>
    );
  }

  if (Math.abs(change) < 0.5) {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1 text-xs text-ink-subtle',
          className,
        )}
      >
        <Minus className="size-3" /> 0%
      </span>
    );
  }

  const positive = change > 0;
  const Icon = positive ? ArrowUpRight : ArrowDownRight;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 text-xs font-medium',
        positive ? 'text-positive' : 'text-critical',
        className,
      )}
    >
      <Icon className="size-3.5" />
      {Math.abs(change).toFixed(0)}%
    </span>
  );
};
